import { Component, input, Input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  AwFormFieldLabelComponent,
  AwFormMessageComponent,
  AwSelectMenuComponent,
  SingleSelectOption,
} from '@assetworks-llc/aw-component-lib';

function isOption(value: unknown): value is SingleSelectOption {
  return !!value && !Array.isArray(value) && typeof value === 'object' && 'label' in value;
}

@Component({
    selector: 'app-aw-dropdown-form',
    imports: [
        ReactiveFormsModule,
        AwFormFieldLabelComponent,
        AwFormMessageComponent,
        AwSelectMenuComponent,
    ],
    templateUrl: './aw-dropdown-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './aw-dropdown-form.component.scss'
})
export class AwDropdownFormComponent implements OnInit {
  options = input<SingleSelectOption[]>([]);
  title = input<string>('');
  required = input<boolean>(true);
  label = input<string | null>('');
  /** Shown while nothing is selected, e.g. 'Filter on Status' on a table filter. */
  placeholder = input<string>('');

  currentOption = output<SingleSelectOption | null>();

  selectDropdownForm!: FormGroup;
  ngOnInit(): void {
    this.selectDropdownForm = new FormGroup({
      // Only a required menu gets the validator; otherwise clearing it shows CCL's error outline.
      selectOption: new FormControl<any>(this.label(), this.required() ? [Validators.required] : []),
    });
    this.selectDropdownForm.controls['selectOption'].valueChanges.subscribe(
      (option) => {
        // CCL's clear (X) writes an empty array, not null. Anything that isn't an option reaches the page as null.
        this.currentOption.emit(isOption(option) ? option : null);
      }
    );
  }
}
